"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateOpts = void 0;
var _nl = _interopRequireDefault(require("date-fns/locale/nl"));
var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));
var _de = _interopRequireDefault(require("date-fns/locale/de"));
var locales = {
  nl: _nl["default"],
  en: _enGB["default"],
  de: _de["default"]
};
var getDateOpts = exports.getDateOpts = function getDateOpts(locale) {
  return {
    locale: locales[locale]
  };
};
//# sourceMappingURL=dateOpts.js.map